const membershipAction = (membership, add, remove) => {
    if (membership === true) return remove;
    if (membership === false) return add;
    return undefined;
};

module.exports = membershipAction;
module.exports.membershipAction = membershipAction;
